const getSlugFromUrl = ()=>{
    if ("u" < typeof window) return;
    const url = window.location.pathname;
    const segments = url.split('/');
    return segments.length >= 3 && 'org' === segments[1] ? segments[2] : void 0;
};
export { getSlugFromUrl };
